import { render } from "./cage-details.vue?vue&type=template&id=40208361"
import script from "./cage-details.vue?vue&type=script&lang=js"
export * from "./cage-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__